// extracted by mini-css-extract-plugin
module.exports = {"contacts":"bLGcB","contactsRow":"aeoja","contactsGroup":"_8Q1c4","contactsItem":"p0QfK","contactsLink":"CLzFH"};